import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { getCorrectFormatEmployeeInfoField } from 'src/components/employee/employee-details.helpers';

import { generateReactKey } from 'src/common/helpers/common.helpers';

import { HealthInsuranceCardName } from '../health-insurance-card-name';

import { IPaymentAndInsurance } from '../../../../../auth/sub-pages/questionnaire/questionnaire.interfaces';

import {
  InfoBlock,
  InfoBlockContainer,
  InfoElement,
  InfoWrapper,
  InfoWrapperTitle,
} from '../../open-questionnaires-details.styles';

interface IFile {
  location: string;
  filename: string;
}

const PaymentAndInsuranceQuestionnairesDetails = ({
  paymentAndInsurance,
  healthInsuranceCard,
  handleOpenModal,
  healthInsurance,
}: {
  paymentAndInsurance: IPaymentAndInsurance;
  healthInsuranceCard?: IFile;
  handleOpenModal: () => void;
  healthInsurance?: {
    name: string;
    _id: string;
  };
}) => {
  const { t } = useTranslation('employee');

  const {
    bankAccountHolder,
    iban,
    bic,
    typeOfVisa,
    visaExpirationDate,
    nationalInsuranceNumber,
    healthInsuranceType,
    healthInsuranceId,
    workPermissionNeeded,
    hasCertificateOfStudy,
    residencePermissionNeeded,
    workPermissionExpireDate,
    residencePermissionExpireDate,
    certificateOfStudyExpireDate,
    taxId,
    healthInsuranceCardName,
  } = paymentAndInsurance;

  const firstColumn = {
    bankAccountHolder,
    iban,
    bic,
    taxId,
    typeOfVisa,
    visaExpirationDate,
    nationalInsuranceNumber,
  };

  const secondColumn = {
    workPermissionNeeded,
    workPermissionExpireDate,
    hasCertificateOfStudy,
    certificateOfStudyExpireDate,
    residencePermissionNeeded,
    residencePermissionExpireDate,
  };

  const thirdColumn = {
    healthInsuranceType,
    healthInsuranceId,
    healthInsuranceCardName,
  };

  const data = [firstColumn, secondColumn, thirdColumn];

  return (
    <InfoWrapper>
      <InfoWrapperTitle>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.paymentAndInsurance')}
        </Typography>
      </InfoWrapperTitle>

      <InfoBlock>
        {data.map(el => {
          return (
            <InfoBlockContainer key={generateReactKey()}>
              {Object.entries(el).map(([key, value]) => {
                const _key = key === 'healthInsuranceId' ? 'healthInsuranceName' : key;
                const _value = key === 'healthInsuranceId' ? healthInsurance?.name : value;

                const isHealthInsuranceCardName = _key === 'healthInsuranceCardName';
                return isHealthInsuranceCardName ? (
                  <HealthInsuranceCardName
                    key={generateReactKey()}
                    file={healthInsuranceCard}
                    healthInsuranceCardName={_value}
                    t={t}
                    handleModalOpen={handleOpenModal}
                  />
                ) : (
                  <InfoElement key={generateReactKey()}>
                    <Typography weight="bold">{`${t(
                      `employee:questionnaire.paymentAndInsurance.labels.${_key}`
                    )}`}</Typography>
                    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                      {getCorrectFormatEmployeeInfoField({ t, key: _key, value: _value }) || '-'}
                    </Typography>
                  </InfoElement>
                );
              })}
            </InfoBlockContainer>
          );
        })}
      </InfoBlock>
    </InfoWrapper>
  );
};

export default PaymentAndInsuranceQuestionnairesDetails;
